module.exports = __webpack_public_path__ + "img/h_cloud_analytics.7bb70a61.png";